// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"MessageBox_messageBox__1eqmX","success":"MessageBox_success__1JbiA","danger":"MessageBox_danger__155FU"};